module.exports = __webpack_public_path__ + "img/nconsulting-illustration.f8f6c50b.jpeg";